import { render } from "./ExtensionKeys.vue?vue&type=template&id=e9885cd0&scoped=true"
import script from "./ExtensionKeys.vue?vue&type=script&lang=js"
export * from "./ExtensionKeys.vue?vue&type=script&lang=js"

import "./ExtensionKeys.vue?vue&type=style&index=0&id=e9885cd0&scoped=true&lang=css"

import exportComponent from "/go/src/bitbucket.org/VertexSecurity/xsurflog_vuejs/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9885cd0"]])

export default __exports__